import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import {
  FormControlLabel,
  TablePagination,
  Switch,
  Table,
  Paper,
} from '@material-ui/core'
import cn from 'classnames'
import FuncHelper from 'helpers/functions'
import NoData from 'components/common/NoData/NoData'
import MaterialTableHead from './MaterialTableHead'
import MaterialTableBody from './MaterialTableBody'
import MaterialTableToolbar from './MaterialTableToolbar'
import 'styles/app/data-table.scss'

const defaultPaginationProps = {
  count: 0,
  page: 0,
  rowsPerPage: 20,
  rowsPerPageOptions: [10, 20, 50, 100],
  onChangePage: FuncHelper.emptyFunc,
  onChangeRowsPerPage: FuncHelper.emptyFunc,
}

class MaterialTable extends Component {
  constructor(props) {
    super(props)
    this.tableHead = React.createRef()
  }

  getPagination = props => {
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <TablePagination
        {...props}
        component="div"
        className="table-pagination"
        labelRowsPerPage={formatMessage({ id: 'rows_per_page' })}
        backIconButtonProps={{
          'aria-label': formatMessage({ id: 'previous_page' }),
        }}
        nextIconButtonProps={{
          'aria-label': formatMessage({ id: 'next_page' }),
        }}
      />
    )
  }

  getDensePaddingSwitcher = () => {
    const {
      intl: { formatMessage },
      dense: { state, handler },
    } = this.props

    return (
      <FormControlLabel
        label={formatMessage({ id: 'dense_padding' })}
        className="dense-control"
        control={
          <Switch
            href={null}
            color="primary"
            checked={state}
            onChange={handler}
          />
        }
      />
    )
  }

  showAlwaysTableHead(paginationProps) {
    const {
      intl: { formatMessage },
      responsive,
      columns,
      actions,
      sorting,
      sort,
      data,
      dense,
      onRowClick,
      onRowSelect,
      paging,
      className,
      alwaysShowTableHead,
      lang,
      showAdditionalRows,
      combinedColumns,
      styles,
      cellClassName,
      selectedRowId,
    } = this.props
    const spanish = lang === 'es' && 'spanish'
    const isVerticalScrollExist = data && data.length > 6
    const isDenseExist = dense && dense.enabled

    return (
      <Paper
        className={cn('table-content', {
          'responsive-table': responsive,
          [className]: className,
        })}>
        <div>
          <Table
            aria-labelledby="tableTitle"
            className={cn({
              spanish,
              'vertical-scroll': isVerticalScrollExist,
            })}>
            {alwaysShowTableHead && (
              <MaterialTableHead
                {...{
                  columns,
                  actions,
                  sorting,
                  sort,
                  styles,
                  cellClassName,
                  formatMessage,
                }}
              />
            )}
            {data && data.length > 0 && alwaysShowTableHead && (
              <MaterialTableBody
                {...{
                  columns,
                  data,
                  actions,
                  onRowClick,
                  onRowSelect,
                  showAdditionalRows,
                  combinedColumns,
                  dense,
                  styles,
                  cellClassName,
                  selectedRowId,
                }}
              />
            )}
          </Table>
        </div>
        <div className="controls">
          {isDenseExist && this.getDensePaddingSwitcher()}
          {paging && this.getPagination({ ...paginationProps })}
        </div>
      </Paper>
    )
  }

  render() {
    const {
      intl: { formatMessage },
      classes,
      responsive,
      psfs,
      title,
      columns,
      actions,
      data,
      dense,
      noDataMessage,
      showFilterBar,
      sorting,
      paging,
      searching,
      filtering,
      creating,
      sort,
      paginator,
      search,
      filters,
      createButton,
      goBack,
      onRowClick,
      onRowSelect,
      className,
      alwaysShowTableHead,
      showAdditionalRows,
      combinedColumns,
      styles,
      cellClassName,
      selectedRowId,
      stickyHeader,
      tableRef,
    } = this.props
    const paginationProps = paginator
      ? Object.assign(defaultPaginationProps, paginator)
      : defaultPaginationProps
    const isDenseExist = dense && dense.enabled

    return (
      <>
        {showFilterBar && (
          <div className="table-toolbar">
            <MaterialTableToolbar
              {...{
                classes,
                psfs,
                goBack,
                title,
                filtering,
                filters,
                searching,
                search,
                creating,
                createButton,
              }}
            />
          </div>
        )}
        {alwaysShowTableHead
          ? this.showAlwaysTableHead(paginationProps)
          : Boolean(Array.isArray(data) && data.length > 0) && (
              <Paper
                className={cn('table-content', {
                  'responsive-table': responsive,
                  [className]: className,
                })}>
                <div
                  ref={tableRef}
                  className={cn('table-wrapper', {
                    'sticky-header': stickyHeader,
                  })}>
                  <Table aria-labelledby="tableTitle">
                    <MaterialTableHead
                      {...{
                        columns,
                        actions,
                        sorting,
                        sort,
                        styles,
                        cellClassName,
                        formatMessage,
                        tableHeadRef: this.tableHead,
                      }}
                    />
                    <MaterialTableBody
                      {...{
                        columns,
                        data,
                        actions,
                        onRowClick,
                        onRowSelect,
                        styles,
                        showAdditionalRows,
                        combinedColumns,
                        dense,
                        cellClassName,
                        selectedRowId,
                      }}
                    />
                  </Table>
                </div>
                <div className="controls">
                  {isDenseExist && this.getDensePaddingSwitcher()}
                  {paging && this.getPagination({ ...paginationProps })}
                </div>
              </Paper>
            )}
        {Boolean(!data || data.length === 0) && (
          <div className="container-fluid table-without-data no-breadcrumb">
            <NoData message={noDataMessage} />
          </div>
        )}
      </>
    )
  }
}

export default injectIntl(MaterialTable)
